module.exports = __webpack_public_path__ + "static/media/appicon1.898ed278.png";